import { UserTypes } from 'modules/User';

import { getThumbnailUrlFromCDN } from './ElementsMenu.helpers';
import { ElementsPackTypes } from './ElementsMenu.types';

export const THUMBNAIL_BUTTON_HEIGHT = 135;
export const THUMBNAIL_IMAGE_HEIGHT = 100;
export const THUMBNAIL_IMAGE_WIDTH = 125;
export const THUMBNAIL_IMAGE_WIDTH_WITH_CAPTION = 105;
export const THUMBNAIL_IMAGE_HEIGHT_WITH_CAPTION = 80;
export const DEFAULT_ELEMENT_PERMISSION = UserTypes.Free;

export const ELEMENTS_PACKS = [
  {
    id: ElementsPackTypes.InteractiveList,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_interactivelist', imgType: 'png' }),
      altText: 'Add interactive list',
    },
  },
  {
    id: ElementsPackTypes.TextBlocks,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_textblock_7', imgType: 'png' }),
      altText: 'Text Blocks',
    },
  },
  {
    id: ElementsPackTypes.Lists,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_list_3', imgType: 'png' }),
      altText: 'Lists',
    },
  },
  {
    id: ElementsPackTypes.Signatures,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_signature_2', imgType: 'png' }),
      altText: 'Signatures',
    },
  },
  {
    id: ElementsPackTypes.ImageFrames,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_imageframe_2', imgType: 'png' }),
      altText: 'Image Frames',
    },
  },
  {
    id: ElementsPackTypes.ImageGrids,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_imagegrid_5', imgType: 'png' }),
      altText: 'Image Grids',
    },
  },
  {
    id: ElementsPackTypes.VideoEmbed,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_video', imgType: 'png' }),
      altText: 'Video',
    },
  },
  {
    id: ElementsPackTypes.Gifs,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_gif', imgType: 'png' }),
      altText: 'Gifs',
    },
  },
  {
    id: ElementsPackTypes.QRCode,
    thumbnail: {
      src: getThumbnailUrlFromCDN({ assetName: 'vg_elements_thumbnail_qr_code', imgType: 'png' }),
      altText: 'QR Code',
    },
  },
];
